import { render, staticRenderFns } from "./CategorySeleteInput.vue?vue&type=template&id=18b2079a&scoped=true"
import script from "./CategorySeleteInput.vue?vue&type=script&lang=js"
export * from "./CategorySeleteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2079a",
  null
  
)

export default component.exports